import {isString} from 'lodash';
import {mixed, date as originDate, DateSchema} from 'yup';
import {CONTEXT_SEND_PARAMETER} from '../constants';

export const date = () =>
   mixed().when(CONTEXT_SEND_PARAMETER, {
      is: true,
      then: mixed().transform(function (val, origin: Date) {
         // console.debug(isString(val), val, origin);
         if (isString(val) || !origin) {
            return val;
         }

         // const day = dayjs(origin);
         // if (!day.isValid()) return null;
         // console.debug(origin.toISOString().split('.')[0] + 'Z');
         return origin.toISOString().split('.')[0] + 'Z';
      }),
      otherwise: originDate()
         .nullable()
         .default(null)
         .transform(function (val, origin) {
            if (this.isType(val)) return val;

            return new Date(origin);
         }),
   }) as DateSchema<Date>;
